// extracted by mini-css-extract-plugin
export var parent = "menuSection-module--parent--B8+uU";